import React from 'react';
import { Link } from "react-router-dom";
 
function Page404 (){
    
    return (
        <section className="faith h-100">
            <div className="container">
                <div className="parent" style={{width: '100%', minHeight: '700px'}}>
                    <div className="container d-flex flex-column justify-content-center align-items-center">
                        <h1 className="success-title text-center">Oopps! Nothing was found.</h1>
                        <p className="success-text mb-5 text-center">The page you were looking for could not be found.</p>
                        <Link to='/' className="btn btn-return py-3">Back to Home Page</Link>
                    </div>
                </div>
            </div>
        </section>
    )
}
 
export default Page404;